import React from 'react';
import s from './PrivateBanking.module.css';
import check_circle_blue from '../../assets/img/check_circle_blue.svg';
import private_banking_banner from '../../assets/img/private_banking_banner.png';
import { motion } from 'framer-motion';
import Hero from '../../components/hero/Hero';
import { useTranslation } from 'react-i18next';
import {Helmet} from "react-helmet-async";

const PrivateBanking = () => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>

      <Helmet>
        <title>Private Banking Services for Global | Wall Street IBU</title>
        <meta
            name="description"
            content="Secure private banking solutions and offshore banking solutions for high-net-worth clients.
            Personalized service, international accounts, and global financial access with Wall Street IBU."
        />
        <meta name="keywords" content="private banking services, offshore banking solutions, international private banking,
        offshore banking services"/>
      </Helmet>

      <motion.div
        initial={{ opacity: 0, scale: 1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className={s.motion_div}
      >
        <div className={s.content}>
          <Hero
            title_1={t('privateBanking.heroTitle1')}
            title_2={t('privateBanking.heroTitle2')}
            description={t('privateBanking.heroDescription')}
          />

          <div className={s.flex}>
            <div className={s.left}>
              <p>
                {t('privateBanking.paragraph1.part1')}{' '}
                <span className={s.bold}>{t('privateBanking.paragraph1.bold')}</span>
              </p>
              <p>{t('privateBanking.paragraph2')}</p>
              <p>{t('privateBanking.paragraph3')}</p>
            </div>
            <div className={s.right}>
              <img src={private_banking_banner} alt="" />
            </div>
          </div>

          <div className={s.services_list_block}>
            <div className={s.services_list_block_title}>
              {t('privateBanking.servicesListBlockTitle')}
            </div>
            <div className={s.flex}>
              <div className={s.left}>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('privateBanking.serviceList.left.line1')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('privateBanking.serviceList.left.line2')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('privateBanking.serviceList.left.line3')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('privateBanking.serviceList.left.line4')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('privateBanking.serviceList.left.line5')}
                  </div>
                </div>
              </div>
              <div className={s.right}>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('privateBanking.serviceList.right.line1')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('privateBanking.serviceList.right.line2')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('privateBanking.serviceList.right.line3')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('privateBanking.serviceList.right.line4')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('privateBanking.serviceList.right.line5')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={s.gradient}>
            <div className={s.gradient_title}>
              {t('privateBanking.gradientTitle')}
            </div>
            <div className={s.flex}>
              <div className={s.left}>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.gradient_text}>
                    {t('privateBanking.gradientLeft.line1')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('privateBanking.gradientLeft.line2')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('privateBanking.gradientLeft.line3')}
                  </div>
                </div>
              </div>
              <div className={s.right}>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('privateBanking.gradientRight.line1')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('privateBanking.gradientRight.line2')}
                  </div>
                </div>
              </div>
            </div>
            <div className={s.gradient_footer}>
              {t('privateBanking.gradientFooter')}
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PrivateBanking;
